export const COSIGNATURE_ACKNOWLEDGEMENT =
  "By co-signing, I acknowledge that I have reviewed the clinical documentation and agree with the plan of care.";
